var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.name !== 'login')?_c('app-header'):_vm._e(),_c('div',{staticStyle:{"min-height":"100vh"}},[_vm._t("default")],2),(_vm.$route.name !== 'login')?_c('app-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }